export default {
  login: {
    title: 'Log Masuk',
    username: 'Nama Pengguna',
    phone: 'Nombor Telefon',
    phoneCode: 'Kod',
    email: 'E-mel',
    password: 'Kata Laluan',
    captcha: 'Captcha',
    loading: 'Memuatkan...',
    rememberMe: 'Ingat saya',
    forgotPassword: 'Lupa Kata Laluan?',
    loginButton: 'Log Masuk',
    contactUs: 'Hubungi Kami？',
    noAccount: 'Belum ada akaun?',
    registerNow: 'Daftar',
    or: 'ATAU',
    orSignInWith: 'Atau log masuk dengan',
    methodUsername: 'Nama Pengguna',
    methodPhone: 'Telefon',
    methodEmail: 'E-mel',
    usernameRequired: 'Nama pengguna diperlukan',
    phoneRequired: 'Nombor telefon diperlukan',
    emailRequired: 'E-mel diperlukan',
    passwordRequired: 'Kata laluan diperlukan',
    captchaRequired: 'Captcha diperlukan',
    resetPassword: 'Tetapkan Semula Kata Laluan',
    resetStep1Hint: 'Masukkan nombor telefon atau e-mel anda untuk menerima kod pengesahan.',
    useEmailInstead: 'Gunakan e-mel',
    usePhoneInstead: 'Gunakan telefon',
    sendCode: 'Hantar Kod',
    resetStep2Hint: 'Kod pengesahan telah dihantar ke',
    verificationCode: 'Kod Pengesahan',
    verificationCodeRequired: 'Kod pengesahan diperlukan',
    resendIn: 'Hantar semula dalam',
    resendCode: 'Hantar Semula Kod',
    verify: 'Sahkan',
    resetStep3Hint: 'Tetapkan kata laluan baharu anda.',
    newPassword: 'Kata Laluan Baharu',
    confirmPassword: 'Sahkan Kata Laluan',
    passwordMinLength: 'Kata laluan mestilah sekurang-kurangnya 6 aksara',
    confirmPasswordRequired: 'Sila sahkan kata laluan anda',
    passwordMismatch: 'Kata laluan tidak sepadan',
    resetPasswordBtn: 'Tetapkan Semula Kata Laluan',
    back: 'Kembali',
    // Format validation
    emailFormat: 'Format e-mel tidak sah',
    // Toast messages
    loginSuccess: 'Log masuk berjaya',
    loginFailed: 'Log masuk gagal',
    signInWithGoogle: 'Log masuk dengan Google+',
    codeSent: 'Kod pengesahan dihantar',
    sendCodeFailed: 'Gagal menghantar kod',
    invalidCode: 'Kod pengesahan tidak sah',
    resetSuccess: 'Kata laluan berjaya ditetapkan semula',
    resetFailed: 'Gagal menetapkan semula kata laluan'
  }
};
